//кнопка вверх
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 10) {
            $('#scroll').css('display', 'block');
            $('header').addClass('fixed');
        } else {
            $('#scroll').css('display', 'none');
            $('header').removeClass('fixed');
        }
    });
    $('#toTop').click(function () {
        $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
        return false;
    });

});

// let snowCount = 200;
// if ($(window).width() < 992) {
//     snowCount = 100;
// } else {
//     snowCount = 200;
// }
//
// $(document).ready(function () {
//
//     $(document).snowfall({
//         flakeCount: snowCount,
//         image: "../../images/snow1.png",
//         minSize: 10,
//         maxSize: 20
//     });
// });

if (document.getElementsByClassName('image-text-link').length > 0) {
    $('.image-text-link').magnificPopup({type: 'image'});
}

function findVideos() {
    let videos = document.querySelectorAll('.video');

    for (let i = 0; i < videos.length; i++) {

        setupVideo(videos[i]);
    }
}

function setupVideo(video) {
    let link = video.querySelector('.video__link');
    let media = video.querySelector('.video__media');
    let button = video.querySelector('.video__button');
    let id = parseMediaURL(media);

    video.addEventListener('click', () => {
        let iframe = createIframe(id);

        link.remove();
        button.remove();
        video.appendChild(iframe);
    });

    link.removeAttribute('href');
    video.classList.add('video--enabled');
}

function parseMediaURL(media) {
    let regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/sddefault\.jpg/i;
    let url = media.src;
    let match = url.match(regexp);

    return match[1];
}

function createIframe(id) {
    let iframe = document.createElement('iframe');

    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('src', generateURL(id));
    iframe.classList.add('video__media');

    return iframe;
}

function generateURL(id) {
    let query = '?rel=0&showinfo=0&autoplay=1';

    return 'https://www.youtube.com/embed/' + id + query;
}

findVideos();

$('.video-slider').slick();


//открытие/закрытие текста
$('.screen.seo-text .read-more').click(function () {
    $('.screen.seo-text .background').toggleClass('active');

    if ($('.screen.seo-text .background').hasClass('active')) {
        $('.screen.seo-text .read-more').text(Lang.get('js.hide'));
    } else {
        $('.screen.seo-text .read-more').text(Lang.get('js.show_more'));
    }
});

$('.trade-marks-slider').slick();
$('.main-recipes-block-slick').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
            }
        }
    ]
});
$('.product-item-parent-slick').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    dots: true,
    adaptiveHeight: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                adaptiveHeight: true
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true
            }
        }
    ]
});

$('.history-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    dots: true,
    arrows: false,
    appendDots: '#history-dots',
    customPaging: function (slider, i) {
        var title = $(slider.$slides[i].innerHTML).find('div[data-title]').data('title');
        return '<span class="dot"><div class="year">' + title + '</div></span>';
    }
});


$('header nav>ul>li.expanded>.menu-item-arrow, .nav-menu nav>ul>li.expanded>.menu-item-arrow').click(function (e) {
    if ($(window).width() < 991) {
        e.preventDefault();
        // $('header nav>ul>li').removeClass('open d-block');
        // $('header nav>ul>li').addClass('d-none');
        // $(this).parent('li').addClass('open');
        $('header nav>ul>li:not(.logo)').addClass('not-open');
        $(this).parent('li').removeClass('not-open');
        $(this).parent('li').addClass('open');

    }
});
$('.mobi-back').click(function (e) {
    if ($(window).width() < 991) {
        // console.log($(this));
        e.preventDefault();
        $('header nav>ul>li:not(.logo)').removeClass('not-open');
        $('header nav>ul>li.expanded').removeClass('open');
    }
});

$('.product-preview-rating-block .raiting').click(function (e) {
    $('html, body').animate({scrollTop: $('#commentary').offset().top}, 'slow');
    $('#show-review-form').click();
    return;
});
$('.first-block .media').click(function (e) {
    $('html, body').animate({scrollTop: $('.main-video').offset().top}, 'slow');
    return;
});


//paralax main screen
if ($(window).width() < 992) {
    $('.modal-menu .menu ul li.expanded .expanded-item').click(function (e) {
        $(this).parent().children('.sub-menu').addClass('open-sub-menu');
        e.preventDefault();
    });
    $('.mobi-back').click(function () {
        $(this).parent('.sub-menu').removeClass('open-sub-menu');
    });
} else {
    setTimeout(function () {
        $(".home header").animate({top: 0}, 1000);
        $(".first-screen .makers").animate({bottom: '100px'}, 1000, function () {
            $(".first-screen .first-screen-content .text").animate({left: 0}, 1000);
            $(".first-screen .soc-link-list").animate({right: '15px'}, 1000);
        });

    }, 700);
}


//menu
const menu = document.querySelector('.hidden-menu');
const btnBurgerHidden = document.getElementById('btn-burger-hidden');
const btnBurgerOpen = document.getElementById('btn-burger-open');
// console.log(btnBurgerHidden);


if (btnBurgerHidden) {
    btnBurgerHidden.addEventListener('click', function () {
        menu.classList.toggle('open-menu');
        btnBurgerHidden.classList.toggle('active');
        btnBurgerOpen.classList.toggle('active');
        btnBurgerHidden.classList.toggle('not-active');
        btnBurgerOpen.classList.toggle('not-active');
        $('body').toggleClass('active');
    }, false);
}

if (btnBurgerOpen) {
    btnBurgerOpen.addEventListener('click', function () {
        menu.classList.toggle('open-menu');
        btnBurgerHidden.classList.toggle('active');
        btnBurgerOpen.classList.toggle('active');
        btnBurgerHidden.classList.toggle('not-active');
        btnBurgerOpen.classList.toggle('not-active');
        $('body').toggleClass('active');
    }, false);
}

if ($(window).width() > 992) {
    $(".modal-menu .menu ul li.expanded").hover(
        function () {
            $(".modal-menu .menu ul li.expanded .sub-menu li").each(function (i) {
                setTimeout(function () {
                    $(".modal-menu .menu ul li.expanded .sub-menu li").eq(i).addClass('show_li');
                }, 50 * (i + 1));
            });
        }, function () {
            $(".modal-menu .menu ul li.expanded .sub-menu li").removeClass('show_li');
        }
    );
}


//paralax продукция
if ($(window).width() > 992) {
    let wScroll = $(this).scrollTop();
    if ($('.vacancies-advantage-block').offset()) {
        if (wScroll > $('.vacancies-advantage-block').offset().top - ($(window).height() / 2)) {

            $(".vacancies-advantage-block .adv-item").each(function (i) {
                setTimeout(function () {
                    $(".vacancies-advantage-block .adv-item").eq(i).addClass('show_li');
                }, 250 * (i + 1));
            });
        }

    }

    $(window).scroll(function () {

        var wScroll = $(this).scrollTop();
        if ($('.main-product-grid').offset()) {
            if (wScroll > $('.main-product-grid').offset().top - ($(window).height() / 2)) {
                $(".main-product-grid .collage-item").each(function (i) {
                    setTimeout(function () {
                        $(".main-product-grid .collage-item").eq(i).addClass('show_li');
                    }, 250 * (i + 1));
                });
            }
        }

        if ($('.advantage-block').offset()) {
            if (wScroll > $('.advantage-block').offset().top - ($(window).height() / 2)) {
                $(".advantage-block .adv-item").each(function (i) {
                    setTimeout(function () {
                        $(".advantage-block .adv-item").eq(i).addClass('show_li');
                    }, 250 * (i + 1));
                });
            }
        }

        if ($('.vacancies-advantage-block').offset()) {
            if (wScroll > $('.vacancies-advantage-block').offset().top - ($(window).height() / 2)) {
                $(".vacancies-advantage-block .adv-item").each(function (i) {
                    setTimeout(function () {
                        $(".vacancies-advantage-block .adv-item").eq(i).addClass('show_li');
                    }, 250 * (i + 1));
                });
            }
        }

        if ($('.about-sidebar').offset()) {
            if (wScroll > $('.about-sidebar').offset().top - ($(window).height() / 2)) {
                $(".about-sidebar .about-sidebar-link").each(function (i) {
                    setTimeout(function () {
                        $(".about-sidebar .about-sidebar-link").eq(i).addClass('show_li');
                    }, 250 * (i + 1));
                });
            }
        }

        if ($('.numbers-screen').offset()) {
            if (wScroll > $('.numbers-screen').offset().top - ($(window).height() / 2)) {
                $(".numbers-screen .numbers-item").each(function (i) {
                    setTimeout(function () {
                        $(".numbers-screen .numbers-item").eq(i).addClass('show_li');
                    }, 250 * (i + 1));
                });
            }
        }

    });
}

function innerHtmlFormVacancy(pathDiv) {
    console.log($(pathDiv + ' .vacancy-form-id'));
    document.getElementsByClassName(pathDiv + " .vacancy-form-id")[0].innerHTML =
        '<div id="vacancy-form">' +
        '    <form-vacancy></form-vacancy>' +
        '</div>';
}

$('.close-popup-vacancy').click(function () {
    $(".popup-vacancy").removeClass("active");
});

//Тупое решение на очень скорую руку
$('.vacancy-item-preview .vacancy-name').click(function (e) {
    let currentParent = this.closest(".vacancy-item-preview");

    // if( !currentParent.classList.contains('active')) {
    if (!this.classList.contains('active')) {
        $(".vacancy-item-preview.active").toggleClass("active");
        $(".vacancy-name.active").toggleClass("active");
        $(".vacancy-item-content.active").toggleClass('active');
    }
    this.classList.toggle('active');
    currentParent.classList.toggle('active');
    let selectorContent = this.getAttribute('data-vacancy-block');
    document.getElementsByClassName(selectorContent)[0].classList.toggle('active');
});


$(document).ready(function () {
    if ($(window).width() > 767) {
        const animItemsBottomToTop = document.querySelectorAll('.first-block-animate-bottomtotop');
        const animItemsLeftToRight = document.querySelectorAll('.first-block-animate-lefttoright');
        const animItemsRightToLeft = document.querySelectorAll('.first-block-animate-righttoleft');

        if (animItemsBottomToTop.length > 0 || animItemsLeftToRight.length > 0 || animItemsRightToLeft.length > 0) {
            window.addEventListener('scroll', animOnScroll);

            async function animOnScroll() {
                if (animItemsBottomToTop.length > 0) {

                    for (let index = 0; index < animItemsBottomToTop.length; index++) {
                        animationBottomToTop(animItemsBottomToTop[index]);
                        await new Promise(r => setTimeout(r, 400));
                    }
                }

                if (animItemsLeftToRight.length > 0) {
                    for (let index = 0; index < animItemsLeftToRight.length; index++) {
                        animationLeftToRight(animItemsLeftToRight[index]);
                        await new Promise(r => setTimeout(r, 400));
                    }
                }

                if (animItemsRightToLeft.length > 0) {
                    for (let index = 0; index < animItemsRightToLeft.length; index++) {
                        animationLeftToRight(animItemsRightToLeft[index]);
                        await new Promise(r => setTimeout(r, 400));
                    }
                }
            }

            function animationLeftToRight(animateItem) {
                const animItem = animateItem;
                // Высота анимированного блока
                const animItemHeight = animItem.offsetHeight;
                const animItemOffset = offset(animItem).top;
                const animStart = 4;
                //window.innerHeight - высота окна браузера
                let animItemPoint = window.innerHeight - animItemHeight / animStart;

                if (animItemHeight > window.innerHeight) {
                    animItemPoint = window.innerHeight - window.innerHeight / animStart;
                }

                //pageYOffset -- кол-во проскролленных пикселей
                if ((pageYOffset > animItemOffset - animItemPoint) /*&& pageYOffset < (animItemOffset + animItemHeight)*/) {
                    if (!animItem.classList.contains('_active'))
                        animItem.classList.add('_active');
                } else
                    animItem.classList.remove('_active');
            }

            function animationBottomToTop(animateItem) {
                const animItem = animateItem;
                // Высота анимированного блока
                const animItemHeight = animItem.offsetHeight;
                const animItemOffset = offset(animItem).top;
                const animStart = 4;
                //window.innerHeight - высота окна браузера
                let animItemPoint = window.innerHeight - animItemHeight / animStart;

                if (animItemHeight > window.innerHeight) {
                    animItemPoint = window.innerHeight - window.innerHeight / animStart;
                }

                //pageYOffset -- кол-во проскролленных пикселей
                if ((pageYOffset > (animItemOffset - animItemHeight) - animItemPoint) /*&& pageYOffset < (animItemOffset + animItemHeight)*/) {
                    if (!animItem.classList.contains('_active'))
                        animItem.classList.add('_active');
                } else
                    animItem.classList.remove('_active');
            }

            function offset(el) {
                const rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return {
                    top: rect.top + scrollTop,
                    left: rect.left + scrollLeft
                }
            }

            animOnScroll();
        }
    }
});

if (document.getElementById('studentsForm')) {
    console.log(99);
    $(".scroll-link").click(function (event) {
        event.preventDefault(); // Отмена перехода по ссылке
        var headerHeight = $("header").outerHeight(); // Получаем высоту фиксированной шапки
        var target = $("#studentsForm"); // Целевой блок

        if (target.length) {
            $("html, body").animate(
                {
                    scrollTop: target.offset().top - headerHeight // Учитываем шапку
                },
                1000 // Время анимации (мс)
            );
        }
    });
}

function createLadybug() {
    const ladybug = document.createElement('div');
    ladybug.classList.add('ladybug');

    // Выбираем случайную анимацию
    const animations = ['fly1', 'fly2'];
    const randomAnim = animations[Math.floor(Math.random() * animations.length)];
    ladybug.style.animation = `${randomAnim} 12s linear infinite`;

    // Случайное начальное положение по вертикали
    ladybug.style.top = `${Math.random() * 100}vh`;

    document.body.appendChild(ladybug);

    // Удаляем элемент, когда он уходит за границу
    setTimeout(() => {
        ladybug.remove();
    }, 12000);
}

// Создаём божьих коровок каждую секунду
setInterval(createLadybug, 10000);



// WEBPACK FOOTER //
// ./resources/js/snippets/common.js